import { FC } from "react";
import styled, { css } from "styled-components";
import { primaryActive } from "../../typography/alpha";
import { Icon } from "../Icon/Icon";

type StyledCollapsibleProps = {
  $disabled?: boolean;
};

export const StyledCollapsible = styled.div<StyledCollapsibleProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ $disabled }) =>
    $disabled
      ? css`
          cursor: not-allowed;
        `
      : css`
          cursor: pointer;
        `}
`;

type CollapsibleTitleProps = {
  $isOpen: boolean;
  $disabled?: boolean;
};

export const CollapsibleTitle = styled.div<CollapsibleTitleProps>`
  display: flex;
  padding: 8px 0;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  ${primaryActive.subtitle3}
  color: ${({ $disabled, $isOpen }) =>
    ($disabled && "var(--color-primary-200)") ||
    ($isOpen && "var(--color-secondary-800)")};
`;

type CollapsibleContentProps = {
  $height: number;
};

export const CollapsibleContent = styled.div<CollapsibleContentProps>`
  width: 100%;
  box-sizing: border-box;
  padding-left: 8px;
  height: ${({ $height }) => $height}px;
  transition: height 0.1s cubic-bezier(0.21, 0.92, 0.74, 0.88);
  overflow: hidden;
`;

export const CollapsibleContentContainer = styled.div`
  display: flex;
  width: 100%;
  ${StyledCollapsible} {
    ${CollapsibleTitle} {
      font-size: var(--size-font-small);
      font-weight: var(--font-weight-semibold);
    }
    ${StyledCollapsible} > ${CollapsibleTitle} {
      font-weight: var(--font-weight-regular);
    }
  }
`;

type IconProps = {
  $disabled?: boolean;
};

export const IconClosed: FC<IconProps> = ({ $disabled }) => (
  <Icon
    iconName="chevron-down"
    iconSize="small"
    {...($disabled && { variant: "DISABLED" })}
    plain
  />
);
export const IconOpen: FC<IconProps> = ({ $disabled }) => (
  <Icon
    iconName="chevron-up"
    iconSize="small"
    variant={$disabled ? "DISABLED" : "ACTIVE"}
    plain
  />
);
